'use strict';

app.directive('rmChartist', function () {
  /**
   * Replace chartist default point svg with the <circle> svg element
   * @param data
   * @returns {*}
   */
  var replacePoint = function (data) {
    var attrs = {
      cx: [data.x],
      cy: [data.y],
      r: [4], //radius
      //ct:value & ct:meta are the Chartist generated attributes, so let's copy them as well
      'ct:value': [data.value],
      'ct:meta': [data.meta]
    };
    var circle = new Chartist.Svg('circle', attrs, 'ct-circle');
    data.element.replace(circle);
    return angular.element(circle._node);
  };
  return {
    scope: {
      data: '=rmChartist',
      options: '=options'
    },
    link: function ($scope, $element) {
      var options = _.merge({ lineSmooth: false }, $scope.options);
      $element.addClass('ct-chart rm-chartist');
      var chart = new Chartist.Line($element[0], $scope.data, options);
      chart.on('draw', function (data) {
        if (data.type === 'point') {
          var $point = replacePoint(data);
          $point.on('mouseenter', function () {
            $scope.$emit('rm-chartist:point:mouseenter', data, this);
          });
          $point.on('mouseleave', function () {
            $scope.$emit('rm-chartist:point:mouseleave', data, this);
          });
        }
      });
      chart.on('created', function (data) {
        var divider = new Chartist.Svg('line', null, 'ct-label-divider', this, false);
        var offset =  data.axisY.axisLength + data.axisY.gridOffset + 20;
        divider.attr({ x1: '1%', y1: offset, x2: '99%', y2: offset });
        data.svg.append(divider);
      });
      $scope.$on('$destroy', function () {
        if (chart) {
          chart.detach();
        }
      });
    }
  };
});
